import React, {Component} from 'react';
import { translate, Trans } from "react-i18next";
import Draft from './draft';

class W_StudentsList extends Component {
    constructor(props){
        super(props);
        this.state={
            hasError:false,
            newStudentList: this.props.allStudentList,
            isDistrict: this.props.isDistrict
        }
        console.log("this.props.allStudentList",this.props.allStudentList)
        console.log("this.props.isDistrict",this.props.isDistrict)
        console.log("this.props.lunchObj.studentList",this.props.lunchObj.studentList);
        console.log("this.props",this.props);
        this.validateStudents=this.validateStudents.bind(this)
        this.allStudents = this.allStudents.bind(this);
        this.childComponentRef = React.createRef();
    }
    validateStudents=()=>{
        let someSelected=this.props.lunchObj.studentList.some(function (e) {
            return (e.isSelected);
        });
        return someSelected
    }
    
    allStudents() {
        var select_all = document.getElementById("select_all");
        // this.props.onStudentSelectChange('select_all',select_all.checked);
        var checkboxes = document.getElementsByName("students");
        for (let i = 0; i < checkboxes.length; i++) {
            this.props.onStudentSelectChange(i,select_all.checked);
            if(!checkboxes[i].disabled)
            checkboxes[i].checked = select_all.checked; 
        }
    }
render(){
    const { t, i18n } = this.props;
    return(
        <div>
            
            <div className="row">
            <div className="col-md-12">
                    <p>
                    {(!this.validateStudents() && this.state.hasError)? <span className="text-danger"> [<Trans>{'Please select atleast one student in the list'}</Trans>]</span>:null
                    }</p>
                </div>
            </div>
           
                                        {this.props.lunchObj.studentList.length > 0 ? <div className="row">
                                        <div className="col-xs-12 block">
                                            <div className="schoolInfo">
                                                <p><strong><Trans>Select students from the household applying for school meal benefits</Trans>.</strong></p>
                                            </div>
                                        </div>
                                             <div class="styled-input-container styled-input--square">
                                                <div className="styled-input-single col-sm-12">
                                                    <input type="checkbox" name="fieldset-6" id="select_all"  onChange={this.allStudents} />
                                                    <label htmlFor="select_all" style={{margin: '0px 0px 0px -1px'}}><Trans>All</Trans></label>
                                                </div>
                                            </div>
                                        </div> :<div className="col-xs-12 block">
                                            <div className="schoolInfo text-center">
                                                <p><strong><Trans>All students related to this parent, filled application</Trans>.</strong></p>
                                            </div>
                                        </div>}

            <div className="row">
                <div className="col-xs-12">
                <div className="styled-input-container styled-input--square">
                    <ul className="list-group">
                    { this.state.isDistrict===true ?
                        this.state.newStudentList.map((item,k)=>{
                        return <li className="list-group-item" style={{padding:'7px 7px 0px 10px'}}>
                                    <div className="styled-input-single" style={{padding:'1px 0px 5px 40px'}}>
                                        <input id={'stud'+k} checked={item.isSelected} data-idx={k} type='checkbox' name='students' onChange={(e)=>{
                                            let _idx=e.target.getAttribute('data-idx');
                                            this.props.onStudentSelectChange(_idx,e.target.checked?true:false);
                                            if(e.target.checked)
                                                this.setState({hasError:false})
                                                this.childComponentRef.current.formatDraftReqObj();                                                                    
                                        }} /> 
                                        <label htmlFor={'stud'+k}>
                                        {item.lastName+', '+item.firstName}</label>
                                     </div>
                                </li>
                        }):this.props.lunchObj.studentList.map((item,k)=>{
                            return <li className="list-group-item" style={{padding:'7px 7px 0px 10px'}}>
                                        <div className="styled-input-single" style={{padding:'1px 0px 5px 40px'}}>
                                            <input id={'stud'+k} checked={item.isSelected} data-idx={k} type='checkbox' name='students' onChange={(e)=>{
                                                let _idx=e.target.getAttribute('data-idx');
                                                this.props.onStudentSelectChange(_idx,e.target.checked?true:false);
                                                if(e.target.checked)
                                                    this.setState({hasError:false})
                                                    this.childComponentRef.current.formatDraftReqObj();                                                                    
                                            }} /> 
                                            <label htmlFor={'stud'+k}>
                                            {item.lname+', '+item.fname}</label>
                                         </div>
                                    </li>
                            })
                    }   
                    </ul>
                    </div>
                </div>
            </div> 
            <div className="row">
                <div className="col-xs-12">
                        <button className="btn btn-next bg-color-4 btn-xs pull-left" onClick={(e)=>{
                        this.props.jumpToStep(2)
                    }}>
                        <Trans>Previous</Trans>
                    </button>
                    <button className="btn btn-prev btn-xs bg-color-2 pull-right" disabled={this.props.lunchObj.studentList.length > 0 ?false:true} onClick={(e)=>{                       
                            if(!this.validateStudents()){
                                this.setState({hasError:true})
                            }else{
                                this.props.jumpToStep(4);
                                return true;
                            }
                    }}>
                        <Trans>Continue</Trans>
                    </button>
                    <Draft lunchObj={this.props.lunchObj} schoolInfo={this.props.schoolInfo}  ref={this.childComponentRef} />
                </div>
            </div>
        </div>
    )
}
}
export default  translate("translations")(W_StudentsList);



// WEBPACK FOOTER //
// ./src/components/SchoolAdmin/SchoolMealProgram/newLunchApplication/w_selectStudent.jsx